module.exports = __webpack_public_path__ + "assets/img/b24cc3c32f81739e4861cb4865af4592.svg";